export default {
  getHead: () => {
    return [{ name: '학교명' }, { name: '보호구' }, { name: '수령인' },  { name: '작성자' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return func.getContent(value).protectors // 보호구
      case 2: return func.getContent(value).receivers // 수령인
      case 3: return func.getContent(value).stdInfo.writer_name // 작성자
      case 4: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
    case '학교명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '보호구': returnData.push('content$body.protectors*%[:default_skw]%'); break
    case '수령인': returnData.push('content$body.receivers*%[:default_skw]%'); break
    case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
    case '부서명': returnData.push('content$body.stdInfo.section*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }
    return returnData
  },
}
